import BaseService from "../BaseService";
import _ from "lodash";

class ProductService extends BaseService {
    get = async (filter, fields) => {
        var data = await this._api.post("/product/sitemap", filter, { params: { fields: JSON.stringify(fields)  } });
        return data;
    };

   


}
export default ProductService;
